<script>
  import { onMount } from 'svelte';
  let pathSuffix = "/app/apptoweb"
  let isApptoWeb = false
  onMount(()=> {
    pathSuffix = location.pathname.includes("apptoweb") ? "/app/apptoweb" : "";
    isApptoWeb = location.pathname.includes("apptoweb") ? isApptoWeb = true : isApptoWeb = false;
  })
  const Pic_01 = "/assets_default/images/service/debit-card/guide/place/service_debit-card_guide_place_pic_01.webp"
  const secondarycontent_realcard = "/assets_default/images/service/debit-card/secondarycontent_realcard.webp"
  const ChevronIcon = "/assets_default/icons/chevron_right.svg"
  const HheadphonesIcon = "/assets_default/images/service/debit-card/guide/place/headphones.svg"
  const CarIcon = "/assets_default/images/service/debit-card/guide/place/car.svg"
  const MobileIcon = "/assets_default/images/service/debit-card/guide/place/mobile.svg"
  const CleanIcon = "/assets_default/images/service/debit-card/guide/place/clean_hands.svg"
  const NetIcon = "/assets_default/images/service/debit-card/guide/place/net_shopping.svg"
</script>

  <page-header text="使える場所"></page-header>
  <keyvisual-content
    title="全国のコンビニや<br>スーパーなど使えるお店は<br>順次拡大中"
    image="/assets_default/images/service/debit-card/guide/place/service_debit-card_guide_place_kv.webp"
  >
  </keyvisual-content>
  <section class="owd-section spacing:bottom:64">
    <div class="align:center spacing:bottom:12">
      <h3 class="owd-heading:03 align:center spacing:bottom:24">タッチ決済の設定で<br>お店での支払いが可能</h3>
      <p class="owd-text:01 align:left">QUICPay+™（クイックペイプラス）やJCBのタッチ決済は、全国のコンビニやレストラン、タクシーなどで使えます。</p>
    </div>
    <img src={pathSuffix}{Pic_01} width="344" height="211" alt="全国のコンビニやスーパーなど使えるお店は順次拡大中">
    <p class="owd-text:02"><strong><a href="https://www.quicpay.jp/shoplist/" target="_blank" class="owd-textlink:blank">QUICPay™（クイックペイ）が使えるお店はこちら</a></strong></p>
  </section>
  <section class="owd-section spacing:bottom:64">
    <div class="align:center spacing:bottom:24">
      <h3 class="owd-heading:03 align:center spacing:bottom:24">リアルカードの申込みで、<br>タッチ決済が使えないお店でも</h3>
      <p class="owd-text:01 align:left">リアルカードを申込めば、スマホのタッチ決済が使えないお店や海外でのショッピングなど使える場所がさらに広がります。</p>
    </div>
    <img class="spacing:bottom:24" src={pathSuffix}{secondarycontent_realcard} width="344" height="211" alt="全国のコンビニやスーパーなど使えるお店は順次拡大中">
    <div class="show:sp spacing:bottom:24">
      <div class="block:center spacing:bottom:16">
        <a href="https://minna-no-ginko.go.link/?tp=pg&pg=dri&adj_t=1t7cnj1g" class="owd-button owd-button:large owd-button:secondary:white">リアルカードを申込む</a>
      </div>
      <p class="owd-information align:center"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
    </div>
    <ul class="owd-list:annotation">
      <li>リアルカードは発行手数料として1,100円（税込）がかかります。（プレミアム会員は無料）</li>
    </ul>
  </section>
  <section class="owd-section spacing:bottom:64">
    <div class="align:center spacing:bottom:24">
      <h3 class="owd-heading:03 align:center spacing:bottom:24">バーチャルデビットカードで、<br>ネットショッピングや<br>各種支払いに</h3>
      <p class="owd-text:01 align:left">ネットショッピングはもちろん、公共料金や通信料金、税金などの支払いに使えます。</p>
    </div>
    <div class="owd-featurelist-wrap bg-colors:light-gray spacing:bottom:24">
      <ul class="owd-featurelist owd-featurelist:small">
        <li class="owd-featurelist-item">
          <div class="owd-featurelist-item-iconarea bg-colors:primary-wh">
            <img src={pathSuffix}{NetIcon} alt="ショッピングアイコン">
          </div>
          <div>
            <p class="owd-text:02"><strong>ネットショッピング</strong></p>
          </div>
        </li>
        <li class="owd-featurelist-item">
          <div class="owd-featurelist-item-iconarea bg-colors:primary-wh">
            <img src={pathSuffix}{CleanIcon} alt="クリーンアイコン">
          </div>
          <div>
            <p class="owd-text:02 spacing:bottom:8"><strong>公共料金</strong></p>
            <p class="owd-caption">水道・ガス・電気代など</p>
          </div>
        </li>
        <li class="owd-featurelist-item">
          <div class="owd-featurelist-item-iconarea bg-colors:primary-wh">
            <img src={pathSuffix}{MobileIcon} alt="携帯アイコン">
          </div>
          <div>
            <p class="owd-text:02 spacing:bottom:8"><strong>通信料金</strong></p>
            <p class="owd-caption">電話・プロバイダー料金など</p>
          </div>
        </li>
        <li class="owd-featurelist-item">
          <div class="owd-featurelist-item-iconarea bg-colors:primary-wh">
            <img src={pathSuffix}{CarIcon} alt="車アイコン">
          </div>
          <div>
            <p class="owd-text:02 spacing:bottom:8"><strong>税金</strong></p>
            <p class="owd-caption">自動車税・住民税など</p>
          </div>
        </li>
        <li class="owd-featurelist-item">
          <div class="owd-featurelist-item-iconarea bg-colors:primary-wh">
            <img src={pathSuffix}{HheadphonesIcon} alt="ヘッドフォンアイコン">
          </div>
          <div>
            <p class="owd-text:02"><strong>サブスクリプション</strong></p>
          </div>
        </li>
      </ul>
    </div>
    <p class="owd-heading:01 spacing:bottom:16">交通系ICカードのチャージにも！</p>
    <p class="owd-text:02 spacing:bottom:24">デビットカードから交通系ICカードにチャージすることができます。毎回駅でチャージする必要もありません。</p>
    <div class="spacing:bottom:16">
      <p class="owd-text:02"><strong><a href="https://cs-faq.minna-no-ginko.com/faq/show/455" target="_blank" class="owd-textlink">チャージ方法を詳しく見る</a></strong></p>
    </div>
  </section>
  <section class="owd-section spacing:bottom:64">
    <ul class="owd-framedlinklist spacing:bottom:64 modal-none">
      <li class="owd-framedlinklist-item spacing:bottom:12">
        <a href="/service/debit-card/guide/about/" class="owd-framedlinklist-flex">
          <div>
            <p class="owd-heading:04 spacing:bottom:12">デビットカードの基本</p>
            <p class="owd-text:02">クレジットカードや現金払いとの違いは？</p>
          </div>
          <img src={pathSuffix}{ChevronIcon} alt="右矢印アイコン">
        </a>
      </li>
      <li class="owd-framedlinklist-item">
        <a href="/service/debit-card/guide/howto/" class="owd-framedlinklist-flex">
          <div>
            <p class="owd-heading:04 spacing:bottom:12">デビットカードの使い方</p>
            <p class="owd-text:02">まずは使う金額を口座に入金</p>
          </div>
          <img src={pathSuffix}{ChevronIcon} alt="右矢印アイコン">
        </a>
      </li>
    </ul>

    <ul class="owd-list:mix:01">
      <li>
        <p class="owd-heading:05 spacing:bottom:16">申込みに関する注意事項</p>
        <ul class="owd-list:annotation">
          <li>口座開設と同時にアプリ内に自動発行されます。なお、メルカリ支店を利用中の方は、口座開設と同時にバーチャルデビットが発行されません。みんなの銀行アプリをダウンロード後、アプリから申込みが必要です。</li>
          <li>申込みの際、発行審査にお時間がかかる場合があります。</li>
          <li>申込みの結果、デビットカードの発行をお断りさせていただく場合があります。その場合、お断りの理由は回答いたしかねます。</li>
          <li>追加口座ではデビットカードを発行できません。</li>
        </ul>
      </li>
      <li>
        <p class="owd-heading:05 spacing:bottom:16">お店で支払いする場合の注意事項</p>
        <ul class="owd-list:annotation">
          <li>利用のスマートフォンがタッチ決済可能な端末であり、タッチ決済に対応しているお店で利用できます。</li>
          <li>QUICPay™（クイックペイ）はApple Pay、Google Pay に対応しています。</li>
          <li>JCBのタッチ決済はApple Payに対応しています。</li>
          <li>利用の機種に応じ、支払い時の操作が異なります。iPhoneを利用の場合は<a class="owd-textlink:blank" href="https://www.quicpay.jp/guide/iphone/howto.html" target="_blank">こちら</a>を確認してください。Android™ を利用の場合は<a class="owd-textlink:blank" href="https://www.quicpay.jp/guide/android/howto.html" target="_blank">こちら</a>を確認してください。</li>
          <li>お持ちのスマートフォンによっては、顔認証や指紋認証が求められる場合があります。</li>
          <li>Apple Payを利用するには最新バージョンのiOSが必要です。Apple Payに対応しているデバイスについては<a class="owd-textlink:blank" href="https://support.apple.com/ja-jp/102896" target="_blank">こちら</a>を確認してください。</li>
          <li>Apple Payは、米国およびほかの国々で登録されたApple Inc. の商標です。</li>
          <li>Google Pay は、Google ウォレットアプリをダウンロードできるスマートフォンで使えます。Android OSのバージョンは、<a class="owd-textlink:blank" href="https://support.google.com/wallet/answer/13314575" target="_blank">Google ウォレットのサポートページ</a>を確認してください。</li>
          <li>Android、Google Pay は、Google LLC の商標です。</li>
          <li>QUICPay+は、株式会社ジェーシービーの登録商標です。</li>
        </ul>
      </li>
      <li>
        <p class="owd-heading:05 spacing:bottom:16">ネットで支払いする場合の注意事項</p>
        <ul class="owd-list:annotation">
          <li>3Dセキュア（J/Secure™）とは、ネットショッピングでの第三者による不正利用を防ぐための「本人認証サービス」です。必要に応じて本人認証（パスワード認証）を行います。</li>
        </ul>
      </li>
      <li>
        <p class="owd-heading:05 spacing:bottom:16">デビットカード利用時の注意事項（お店・ネット共通）</p>
        <ul class="owd-list:annotation">
          <li>原則、利用時に普通預金口座から即時引落しとなりますが、一部の加盟店では後日払いとなるケースや差額引落しが発生するケースがあります。その際に口座残高が不足していた場合は、一定期間にわたり振替による引落しの手続きをさせていただきます。</li>
          <li>高速道路料金、ガソリンスタンド、機内販売、登録型加盟店（カード番号を登録し、継続的に利用額を支払いただく加盟店）など、一部利用できない加盟店があります。</li>
          <li>詳しくは<a href="/service/debit-card/summary/" class="owd-textlink">こちら</a>を確認してください</li>
        </ul>
      </li>
    </ul>
  </section>




  <style lang="scss">
    a {
      font-size: inherit;
      &.owd-textlink {
        &\:blank {
          &:after {
            background-image: url(/app/apptoweb/assets_default/icons/arrow_launch.svg);
            background-position-y: 3px;
          }
        }
      }
    }

    * {
      font-size: inherit;
    }
  </style>
